<div class="video-card" [class.completed]="completed" (click)="onClick()">
  <div class="card-icon">
    <mat-icon *ngIf="!completed">play_circle_outline</mat-icon>
    <mat-icon *ngIf="completed" class="check-icon">check_circle</mat-icon>
  </div>

  <div class="card-content">
    <span class="card-title">{{ title }}</span>
    <span class="card-subtitle" *ngIf="!completed">
      {{ 'ClickToWatch' | translate }}
    </span>
    <span class="card-subtitle completed-text" *ngIf="completed">
      {{ 'VideoWatched' | translate }}
    </span>

    <div class="card-progress">
      <mat-progress-bar
        mode="determinate"
        [value]="progress"
        [color]="completed ? 'primary' : 'accent'"
      ></mat-progress-bar>
    </div>
  </div>

  <div class="card-chevron">
    <mat-icon>chevron_right</mat-icon>
  </div>
</div>
